export const promoColors = {
  pink: '#F90479',
  pink2: '#FFEAF2',
  lightPurple: '#EEEAFF',
  purple1: '#BC86FF',
  purple2: '#9F57FC',
  purple3: '#7F30E3',
  purple4: '#52268A',
  newBgPrimary: '#7635db',
}
